import { IonIcon, IonItem, IonLabel, IonList } from '@ionic/react';
import { folderOpenOutline } from 'ionicons/icons';
import { ReactElement, useCallback, useMemo } from 'react';
import { getLocalizedText } from '../../../../../i18n/i18n.utils';
import { FlowItem } from '../../model/flow.types';
import { FlowQuickAction } from './flow-ref';

export enum FlowItemQuickAction {
  INSERT_SECTION = 'INSERT_SECTION',
}

export interface FlowItemQuickActionPopoverProps {
  onDismiss: (action: string) => void;
  selectedItem: FlowItem;
  quickActions?: Record<string, FlowQuickAction>;
}

export interface ItemAction {
  action: string;
  icon: string;
  label: string | undefined;
}

const FlowItemQuickActionPopover = (
  props: FlowItemQuickActionPopoverProps
): ReactElement => {
  const { onDismiss, selectedItem, quickActions } = props;

  const onClick = useCallback(
    (action: string) => {
      onDismiss(action);
    },
    [onDismiss]
  );

  const actions = useMemo<ItemAction[]>(() => {
    const innerActions: ItemAction[] = [
      {
        action: FlowItemQuickAction.INSERT_SECTION,
        icon: folderOpenOutline,
        label: getLocalizedText('common:insert_section'),
      },
    ];

    if (selectedItem) {
      for (const { condition, ui } of Object.values(quickActions ?? {})) {
        if (condition && !condition(selectedItem)) {
          continue;
        }

        innerActions.push({
          action: ui.action,
          icon: ui.icon,
          label: ui.label,
        });
      }
    }

    return innerActions;
  }, [quickActions, selectedItem]);

  return (
    <IonList>
      {actions.map((a, index) => (
        <IonItem
          key={index}
          button={true}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClick(a.action);
          }}
          lines={actions.length - 1 === index ? 'none' : 'full'}
          detail={false}
        >
          <IonLabel>{a.label}</IonLabel>
          <IonIcon slot="start" icon={a.icon}></IonIcon>
        </IonItem>
      ))}
    </IonList>
  );
};

export { FlowItemQuickActionPopover };
